"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
var _lodash = _interopRequireDefault(require("lodash"));
var _elDragDialog = _interopRequireDefault(require("@/directive/el-drag-dialog"));
var _index = _interopRequireDefault(require("@/components/UploadExcel/index.vue"));
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _loop = require("@/api/loop");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import moment from 'moment-timezone'
// import Tinymce from '@/components/Tinymce'
// import QrcodeVue from 'qrcode.vue'
// import { truncate } from '@/filters'
// const defaultValue = []
var _default = exports.default = {
  name: 'LoopEnrollment',
  components: {
    UploadExcelComponent: _index.default
  },
  directives: {
    elDragDialog: _elDragDialog.default
  },
  data() {
    return {
      dialogVisible: false,
      fullscreenloading: false,
      loop: null,
      myLoopTeams: [],
      isShowResult: false,
      noOfSuccess: 0,
      noOfFail: 0,
      tableData: [],
      tableHeader: [],
      smallDrop: 'smallDrop',
      loading: false
    };
  },
  async created() {
    await this.getLoop();
    await this.getLoopParticipants();
  },
  methods: {
    handleDrag() {
      // this.$refs.select.blur()
    },
    openDialog() {
      this.tableData = [];
      this.tableHeader = [];
      this.isShowResult = false;
      this.dialogVisible = true;
    },
    handleSuccess({
      results,
      header
    }) {
      // console.log('upload excel file-result', results)
      // console.log('upload excel file-header', results)
      const loopId = this.loop.id;
      console.info("loop id:" + loopId);
      this.tableData = _lodash.default.map(results, function (r) {
        return {
          loopId: _lodash.default.trim(loopId),
          email: _lodash.default.trim(_lodash.default.toLower(r.email)),
          givenName: _lodash.default.trim(r.givenName),
          familyName: _lodash.default.trim(r.surname),
          orgName: _lodash.default.trim(r.orgName),
          jobTitle: _lodash.default.trim(r.jobTitle)
        };
      });
      this.tableHeader = header;
    },
    beforeUpload(file) {
      // console.log('upload excel file', file)
      return true;
    },
    doUpload() {
      if (this.tableData.length <= 0) {
        const msg = this.$i18n.t('otrTraining.msgEmptyRecord');
        (0, _log.displayPopupMessage)(msg, 'error');
        return false;
      }
      const loopId = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      const oEmail = (0, _cookie.getCookie)('EMAIL');
      this.fullscreenloading = true;
      this.isShowResult = false;
      this.noOfFail = 0;
      this.noOfSuccess = 0;
      this.createAccount();
      (0, _ga.writeGaEvent)(this, 'Loop', `${_lifehikesInitData.userEvent.loop.uploadParticipant}`, oEmail, `Loop Id: ${loopId}`);
    },
    EmailFormatErrorStyle(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return !re.test(email) && email !== '' ? 'error' : '';
    },
    async createAccount() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.isShowResult = true;
      for (let i = 0; i < this.tableData.length; i++) {
        await (0, _loop.enrollLoop)(token, this.tableData[i]).then(response => {
          (0, _log.showDebugLog)('registerEnroll-API-OK', response.data);
          this.tableData[i].result = 'Success';
          this.$set(this.tableData, i, this.tableData[i]);
          (0, _log.showDebugLog)('Table content row', i);
          this.noOfSuccess += 1;
        }).catch(error => {
          // showDebugLog('registerEnroll-API-Fail', error.response)
          const msg = typeof error.response === 'undefined' ? error.toString() : error.response.data.message;
          this.noOfFail += 1;
          this.tableData[i].result = 'Fail:' + msg;
          this.$set(this.tableData, i, this.tableData[i]);
          // showDebugLog('registerEnroll-API-Fail', msg)
          (0, _log.showDebugLog)('Table content row', i);
        });
      }
      await this.getLoopParticipants();
      this.fullscreenloading = false;
    },
    getLoop() {
      const id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loading = true;
      (0, _loop.getLoopById)(token, id).then(response => {
        this.loop = response.data;
        this.loading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('loop-getLoopById-error', error);
        this.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    async getLoopParticipants() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      await (0, _loop.getParticipant)(token, id).then(response => {
        this.myLoopTeams = response.data.rows;
      }).catch(error => {
        (0, _log.showDebugLog)('Loop-getParticipant-API-error', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    backToLoop() {
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      this.$router.push(`/loop/edit/${id}`);
    }
  }
};